
import Navbar from '../../components/feature/Navbar';
import Hero from '../../sections/Hero';
import Services from '../../sections/Services';
import Process from '../../sections/Process';
import Testimonials from '../../sections/Testimonials';
import Trust from '../../sections/Trust';
import FAQ from '../../sections/FAQ';
import Contact from '../../sections/Contact';
import Footer from '../../sections/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Process />
        <Testimonials />
        <Trust />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
